'use client'

import { useTranslations } from 'next-intl'

import { TasksCompleteProfileWarningIcon } from '@/app/[locale]/tasks/components/TasksCompleteProfileDialog/TasksCompleteProfileDialogIcons'
import ModalCloseIcon from '@/assets/icons/modal-close.svg'
import Dialog from '@/ui/Dialog'

import S from './TasksClubOnlyDialog.module.scss'

type TasksClubOnlyDialogProps = {
  open: boolean
  onOpenChange: (open: boolean) => void
}

export function TasksClubOnlyDialog({
  open,
  onOpenChange
}: TasksClubOnlyDialogProps) {
  const t = useTranslations('tasksPage.accessDialogs.clubOnly')

  return (
    <Dialog
      open={open}
      toggle={onOpenChange}
      description={t('description')}
      className={S.dialog}
      withoutClose
    >
      <div className={S.inner}>
        <button
          type="button"
          className={S.cornerClose}
          aria-label={t('closeAria')}
          onClick={() => onOpenChange(false)}
        >
          <ModalCloseIcon className={S.cornerIcon} aria-hidden />
        </button>

        <div className={S.glyph} aria-hidden>
          <TasksCompleteProfileWarningIcon />
        </div>

        <h2 className={S.title}>{t('title')}</h2>
        <p className={S.description}>
          {t('descriptionLine1')}
          <br />
          {t('descriptionLine2')}
        </p>

        <button
          type="button"
          className={S.primaryBtn}
          onClick={() => onOpenChange(false)}
        >
          {t('gotIt')}
        </button>
      </div>
    </Dialog>
  )
}
